import React from 'react';
import { InventoryCard } from './InventoryCard';
import { SummaryDetails } from './SummaryDetails';
import { SummaryNotes } from './SummaryNotes';
import { SummaryProgressBar } from './SummaryProgressBar';
import './SummaryDetailsCard.scss';

/**
 * SummaryDetailsCard Component
 *
 * Extends InventoryCard for displaying summary information with detailed breakdowns.
 */
export const SummaryDetailsCard = ({
    title,
    primaryValue,
    primaryLabel,
    content = [],
    details = [],
    progressBar = [],
    notes = [],
    variant = null,
    className = '',
    showEllipsis = false,
    children,
    ...props
}) => {
    return (
        <InventoryCard
            title={title}
            content={content}
            variant={variant}
            className={className}
            showEllipsis={showEllipsis}
            {...props}
        >
            <SummaryDetails details={details} />
            <SummaryProgressBar progressBar={progressBar} />
            <SummaryNotes notes={notes} className={className} />
            {children}
        </InventoryCard>
    );
};

SummaryDetailsCard.displayName = 'SummaryDetailsCard';

export default SummaryDetailsCard;
